import Axios from "axios";

let CHATBOT_START_API = `${process.env.VUE_APP_CHATBOT_URL}/chatbot/start`;
let CHATBOT_REPLY_API = `${process.env.VUE_APP_CHATBOT_URL}/chatbot/reply`;

class ChatbotService
{
    /**
     * Start a conversation with the chatbot.
     * 
     * @return {Promise}
     */
    static start()
    {
        return new Axios.get(CHATBOT_START_API);
    }

    /**
     * Get a reply from the chatbot.
     * 
     * @param {String} input
     * @param {String} token
     * 
     * @return {Promise}
     */
    static getReply(input, token)
    {
        let body = { input: input, token: token }
        return Axios.post(CHATBOT_REPLY_API, body);
    }

}

export default ChatbotService;